module.exports = __webpack_public_path__ + "static/media/Warly_Portrait.2eba0c65.png";